import React from "react";

import { useBoundingBoxesContext } from "context/boundingBoxesContext";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useSaveAnnotations } from "hooks/useSaveAnnotations/useSaveAnnotations";
import { ConfirmDeleteModal } from "new-components/modals/ConfirmDeleteModal";
import {
  isUnsaveModalOpen,
  setIsUnsaveModalOpen,
  setUnsavedAnnotations,
} from "store/slices/FocusModal/focusModalSlice";
import { ImageQuery } from "types/imageQueries";

type UnsavedAnnotationsConfirmationModalProps = {
  data?: ImageQuery;
  onUnsavedAnnotationsHandled?: (confirmed: boolean) => void;
};

export function UnsavedAnnotationsConfirmationModal({
  data,
  onUnsavedAnnotationsHandled,
}: UnsavedAnnotationsConfirmationModalProps) {
  const { validBoxLabels, annotations, stepsData } = useBoundingBoxesContext();
  const { loadingAddLabel, saveAnnotations } = useSaveAnnotations(annotations, validBoxLabels, stepsData, data);
  const isUnsavedModalOpen = useAppSelector(isUnsaveModalOpen);
  const dispatch = useAppDispatch();

  const onDissmissUnsavedModal = () => {
    dispatch(setIsUnsaveModalOpen(false));
    dispatch(setUnsavedAnnotations(false));
    onUnsavedAnnotationsHandled?.(false);
  };

  const onConfirmUnsavedModal = async () => {
    await saveAnnotations(`${annotations.length || "0"}`, true);
    dispatch(setUnsavedAnnotations(false));
    dispatch(setIsUnsaveModalOpen(false));
    onUnsavedAnnotationsHandled?.(true);
  };

  return (
    <ConfirmDeleteModal
      isDeleteModalOpen={isUnsavedModalOpen}
      setIsDeleteModalOpen={onDissmissUnsavedModal}
      modalTitle="UNSAVED BOUNDING BOXES"
      onRemoveHandler={onConfirmUnsavedModal}
      isLoadingIQDelete={loadingAddLabel}
      buttonTexts={{
        cancelText: "Discard Label",
        successText: "Save New Label",
      }}
      modalContent="Would you like to save this new Ground Truth Label?"
    />
  );
}
